import { createContext, useCallback, useRef, useState } from "react";
import { config } from "../../config";

import type { MomentCardDropData } from "../../modules/moment-card/types/moment-card-drop-data";
import type { UUID } from "../uuid";
import type { FC, ReactNode } from "react";

type MomentCardContextValue =
  | {
      postMessage: (dragId: UUID, data: MomentCardDropData | undefined) => void;
      loaded: true;
    }
  | { loaded: false; postMessage: null };

export const MomentCardDragAndDropContext = createContext<MomentCardContextValue>({
  loaded: false,
  postMessage: null,
});

export const MomentCardDragAndDropProvider: FC<{
  children?: ReactNode;
}> = (props) => {
  const { children } = props;
  const pipeRef = useRef<HTMLIFrameElement>(null);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const postMessage = useCallback(
    (dragId: UUID, data: MomentCardDropData | undefined) => {
      if (!iframeLoaded) return;
      pipeRef.current?.contentWindow?.postMessage(
        {
          type: "moment_drag",
          dragId,
          data,
        },
        { targetOrigin: config.auth0.base_url },
      );
    },
    [iframeLoaded],
  );

  return (
    <MomentCardDragAndDropContext.Provider
      value={iframeLoaded ? { postMessage, loaded: true } : { postMessage: null, loaded: false }}
    >
      <>
        {children}
        <iframe
          title="pipe"
          ref={pipeRef}
          src={`${config.auth0.base_url}/canbus/`}
          width="0"
          height="0"
          style={{ visibility: "hidden", position: "absolute", left: 0, top: 0 }}
          onLoad={() => setIframeLoaded(true)}
        ></iframe>
      </>
    </MomentCardDragAndDropContext.Provider>
  );
};
